module.exports = __webpack_public_path__ + "static/img/29-1.370112c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/29-1.jpg
// module id = T6ud
// module chunks = 0